<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <b-overlay :show="companyLoading" class="rounded" variant="transparent">
            <template #overlay>
              <b-img
                width="100"
                :src="require('@/assets/img/brand/loader.gif')"
                alt=""
              />
            </template>
            <card shadow class="rounded">
              <div slot="header" class="bg-transparent border-0">
                <base-title :title="$t('create_company')" popover="Registro de nueva empresa"></base-title>
              </div>
              <template>
                <createOrUpdate />
              </template>
            </card>
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import createOrUpdate from "../../components/Forms/CompanyForm.vue";
export default {
  name: "create_company",
  components: {
    createOrUpdate,
  },
  computed: {
    ...mapGetters({
      companyLoading: "companyLoading",
    }),
  },
};
</script>